const API_URL = "https://vintariai-backend-1.onrender.com";

export const handleNewChat = async ({ supabase, user }) => {
  const { data, error } = await supabase
    .from("chat_sessions")
    .insert([{ 
      user_id: user.id, 
      title: `New chat — ${new Date().toLocaleString()}` 
    }])
    .select();

  if (error || !data?.[0]) {
    console.error("Couldn’t create session:", error);
    return null;
  }
  return data[0].id;
};

export const handleRenameChat = async ({ supabase, chatId, newTitle }) => {
  await supabase
    .from("chat_sessions")
    .update({ title: newTitle })
    .eq("id", chatId);
};

// ✅ This is the new, corrected version of the delete function
export const handleDeleteChat = async ({ supabase, chatList, chatIdToDelete }) => {
  // Get auth token
  const token = (await supabase.auth.getSession()).data.session?.access_token;
  if (!token) {
    alert("Authentication error. Please log in again.");
    return null;
  }

  // Call the secure backend endpoint to delete the chat
  try {
    const res = await fetch(`${API_URL}/api/chats/${chatIdToDelete}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error("Failed to delete chat on server.");
  } catch (err) {
    console.error("Error deleting chat:", err);
    alert("Failed to delete chat.");
    return null; // Return null on failure
  }
  
  // Clean up this specific conversation from local storage
  localStorage.removeItem(`vintari_conversation_${chatIdToDelete}`);

  // Figure out which chat to switch to next
  const remainingChats = chatList.filter(chat => chat.id !== chatIdToDelete);
  
  if (remainingChats.length === 0) {
    // If no chats are left, clear the current chat ID
    localStorage.removeItem("vintari_current_chat_id");
    return null;
  } else {
    // Otherwise, select the first chat in the remaining list
    return remainingChats[0].id;
  }
};